module.exports = __webpack_public_path__ + "img/1_1_2.af2de0fe.jpg";